import { ModuleConfig } from '@/core/module';
import { crmRoutes } from './routes';
import { useCrmStore } from './stores/crm-store';

export { useInteractions } from './hooks/useInteractions';
export { useTasks } from './hooks/useTasks';
export { useLeads } from './hooks/useLeads';
export { useCrmDashboard } from './hooks/useCrmDashboard';
export * from './types';

export const CrmModule: ModuleConfig = {
    name: 'crm',
    routes: crmRoutes,
    stores: {
        crm: useCrmStore,
    },
    initialize: () => {
        console.log('CRM module initialized');
    },
};
